import { render, staticRenderFns } from "./LeaveRequestTable.vue?vue&type=template&id=6a937303&scoped=true"
import script from "./LeaveRequestTable.vue?vue&type=script&lang=js"
export * from "./LeaveRequestTable.vue?vue&type=script&lang=js"
import style0 from "./LeaveRequestTable.vue?vue&type=style&index=0&id=6a937303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a937303",
  null
  
)

export default component.exports